import apiClient from './apiClient';


// Request to list events
export const listEventsRequest = (data) =>
  apiClient({
    method: 'POST',
    url: '/event-booking/vendors',
    data
  });

// Request to search events
export const searchEventsRequest = (query) =>
  apiClient({
    method: 'GET',
    url: '/event-booking/vendors',
    params: { query },
  });

// Request to filter events
export const filterEventsRequest = (filters) =>
  apiClient({
    method: 'POST',
    url: '/event-booking/vendors',
    data: filters,
  });

// Request to export events
export const exportEventsRequest = (format) =>
  apiClient({
    method: 'GET',
    url: `/events/export`,
    params: { format },
  });

// Request to get provider info
export const getEventInfoRequest = (id) =>
  apiClient({
    method: 'GET',
    url: `/events/${id}`,
  });


// Request to update event info
export const updateEventInfoRequest = (data) => {
  const {id, ...payload} = data || {}; // Ensure id is not included in the data payload
  return apiClient({
    method: 'PUT',
    url: `/event-booking/events/${id}`,
    data: payload,
  });
}

// Request to add an event
export const addEventRequest = (data) =>
  apiClient({
    method: 'POST',
    url: '/event-booking/events/add',
    data,
  });

// Request to download attendees for a specific event
export const downloadAttendeesRequest = (eventId, format = 'csv') =>
  apiClient({
    method: 'GET',
    url: `/event-booking/events/${eventId}/attendees/download`,
    params: { format },
    responseType: 'blob', // ensures file is downloaded correctly
  });

// Request to stop a specific event
export const stopEventRequest = (eventId) =>
  apiClient({
    method: 'POST',
    url: `/event-booking/events/${eventId}/stop`,
  });